import React from 'react';
import PropTypes from 'prop-types';
import CountDownTimer from '../CountDownTimer';
import Time from '~shared/ui/Time/Time';
import {
    DATE_TIME_FORMAT_DD_MMM,
    DATE_TIME_FORMAT_HM,
    DATE_TIME_FORMAT_HM_DD_MMM,
} from '~shared/utils/constants';
import { getLocalizedDateFormat } from '~shared/utils/date-time';
import { useTranslation } from 'react-i18next';

import './styles/event-schedule.scss';

import isToday from 'date-fns/is_today';
import classNames from 'classnames';

const TimeWrapper = ({children, showGreyTimer}) => {

    return (
        <div className={classNames('c-event-schedule__info', { 'c-event-schedule__info--grey': showGreyTimer })} >
            {children}
        </div>
    );
};

TimeWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    showGreyTimer: PropTypes.bool,
};

TimeWrapper.defaultProps = {
    showGreyTimer: false,
};

const EventSchedule = (props) => {
    const {
        startTime,
        isInplay,
        isDateHidden,
        showDateInline,
        showGreyTimer,
        hideCountdownTimer,
    } = props;

    const [t] = useTranslation();

    if (isInplay) {
        return (
            <div className='c-event-schedule__live-tag'>
                {t('event_schedule.live')}
            </div>
        );
    }

    if (!isToday(new Date(startTime))) {
        return (
            <TimeWrapper showGreyTimer>
                <Time
                    dateTime={startTime}
                    format={getLocalizedDateFormat(showDateInline && !isDateHidden ? DATE_TIME_FORMAT_HM_DD_MMM : DATE_TIME_FORMAT_HM)}
                    className='c-event-schedule__info-time'
                />
                {!showDateInline && !isDateHidden && (
                    <Time
                        dateTime={startTime}
                        format={getLocalizedDateFormat(DATE_TIME_FORMAT_DD_MMM)}
                        className='c-event-schedule__info-date'
                    />
                )}
            </TimeWrapper>
        );
    }

    if (hideCountdownTimer) {
        return (
            <TimeWrapper showGreyTimer>
                <Time
                    dateTime={startTime}
                    format={getLocalizedDateFormat(DATE_TIME_FORMAT_HM)}
                    className='c-event-schedule__info-time'
                />
            </TimeWrapper>
        );
    }

    const countdownClassNames = classNames({ 'bb-count-down-timer--grey': showGreyTimer });

    return <CountDownTimer scheduledTime={startTime} styleClass={countdownClassNames} />;
};

EventSchedule.propTypes = {
    startTime: PropTypes.string.isRequired,
    isInplay: PropTypes.bool,
    isDateHidden: PropTypes.bool,
    showDateInline: PropTypes.bool,
    showGreyTimer: PropTypes.bool,
    hideCountdownTimer: PropTypes.bool,
};

EventSchedule.defaultProps = {
    isInplay: false,
    isDateHidden: false,
    showDateInline: false,
    showGreyTimer: false,
    hideCountdownTimer: false,
};

export default EventSchedule;
